module.exports = __webpack_public_path__ + "static/img/2-10w.f5349ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pictures/two/2-10w.png
// module id = w9h/
// module chunks = 1